var OpenpayHelper = (function($) {
    var openpayScriptReady = new $.Deferred();
    var inprogress = false;

    return {
        load: function(src) {
            if (openpayScriptReady.state() === 'pending' && !inprogress) {
                inprogress = true;
                var retry = 0;
                $.getScript(src, function() {
                    var interval = setInterval(function() {
                        retry++;
                        if (window.OpenPay) {
                            clearInterval(interval);
                            openpayScriptReady.resolve();
                        }
                        if (retry === 10) {
                            clearInterval(interval);
                            inprogress = false;
                            openpayScriptReady.reject();
                        }
                    }, 500);
                });
            }
            return openpayScriptReady.promise();
        }
    };
})(jQuery);